<template>
  <div id="tabContainer" class="grid-view">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div v-show="isEdit">
          <el-button no="1" type="primary" :disabled="selectedContainerUsage === null" @click="changeSealHandler">
            {{ $t('SeaExport.SealNoChangeAdfterInspection') }}
          </el-button>
          <el-button no="2" type="primary" @click="autoLoadHandler">{{ $t('SeaExport.AutoAllocation') }}</el-button>
          <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
            {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
          </el-button>
          <el-button
            v-if="!job.lclMasterUuid"
            no="4"
            type="primary"
            :disabled="selectedContainerUsage === null"
            @click="deleteContainerHandler"
          >{{ $t('SeaExport.DeleteTheLoadingRecord') }}
          </el-button>
          <el-button v-if="isFCL" no="5" type="primary" @click="downTemplateBtn_clickHandler">
            {{ $t('SeaExport.TemplateDownload') }}
          </el-button>
          <el-upload
            no="6"
            action="string"
            :http-request="importExcelEventHandler"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUploadUsage"
            style="display: inline-block;margin-left: 5px"
          >
            <el-button v-if="isFCL" v-show="isEdit" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
        </div>
        <div>
          <span>
            {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}
          </span>
        </div>
      </div>
    </div>

    <cargo-ag-grid
      config-module="200001"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="containerUsages || []"
      style="width:100%;height:100%;min-height: 500px"
      @gridReady="params=>gridApi=params.api"
    />
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import { Job } from '@/class/model/booking/Job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import ContainerNoHelper from '@/utils/containerNoHelper'
import StrUtils from '@/utils/StrUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TabError } from '@/utils/class/TabError'
import { sortByMultiField } from '@/utils'
import { importExcelData } from '@/api/seaExport/containerUsage'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { roundHalfUp } from '../../../../../../../utils/NumberUtils'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { syncContainersToExport } from '@/api/SeaImport/seaImportJob'
import CargoAgGridColumnEditGroup2 from '@/components/Cargo/Common/CargoAgGridColumnEditGroup2.vue'

export default {
  name: 'TabContainer',
  components: { SealNumberChangeDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor,
          CargoAgGridColumnEditGroup2
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.itemClickHandler
      },
      gridApi: null,
      boxNoDialog: {
        visible: false
      },
      associatedBusinessDialog: {
        visible: false,
        aData: {}
      },
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      job: new Job().fillDefaultValue().getData(),
      containerUsages: [], // 装箱列表数据List
      selectedContainerUsage: null,
      isFCL: false //  是否为整箱
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    dgContainerEditable() { // 列表是否允许编辑
      return this.isEdit && StrUtils.isEmpty(this.job.lclMasterUuid)
    },
    user() {
      return this.context.user || {}
    },
    columnDefs() {
      const defs =
          [
            {
              headerName: '',
              colId: '',
              field: '',
              width: 65,
              headerCheckboxSelection: true,
              checkboxSelection: true,
              sortable: false,
              suppressMenu: true,
              suppressSizeToFit: true,
              resizable: false
            },
            {
              headerName: this.$t('SeaExport.ContainerSize'),
              colId: 'eqSize',
              field: 'eqSize',
              width: 100,
              cellRendererFramework: 'agGridColumnEdit',
              custom: {
                isEdit: false,
                tag: 'span',
                attrs: {
                  classFunc: (params) => {
                    return ContainerUtil.containerPushDataStyleFunction(params.data, 'eqSize')
                  }
                }
              }
            },
            {
              headerName: this.$t('SeaExport.ContainerType'),
              colId: 'eqType',
              field: 'eqType',
              width: 100,
              cellRendererFramework: 'agGridColumnEdit',
              custom: {
                isEdit: false,
                tag: 'span',
                attrs: {
                  classFunc: (params) => {
                    return ContainerUtil.containerPushDataStyleFunction(params.data, 'eqType')
                  }
                }
              }
            },
            {
              headerName: this.$t('SeaExport.ContainerNo'),
              colId: 'containerNo',
              field: 'containerNo',
              width: 200,
              cellStyle: (params) => {
                return this.containerNbrStyleFunction(params)
              },
              editable: this.dgContainerEditable,
              cellEditor: 'CargoAgGridCommonInputEditor',
              onCellValueChanged: p => {
                const { newValue, oldValue, node, colDef } = p
                if (newValue && newValue.length > 11) {
                  this.$message.warning(this.$t('SeaExport.ContainerNoOutOfRange'))
                  node.setDataValue(colDef.colId, oldValue)
                  return
                }
                const check = JobUtils.checkCNoHandler(this.job, oldValue)
                if (check) {
                  node.setDataValue(colDef.colId, oldValue)
                  return
                }
                this.onCellChange(p)
              }
            },
            {
              headerName: this.$t('SeaExport.ContainerWeight'),
              colId: 'containerWeight',
              field: 'containerWeight',
              width: 100,
              cellStyle: (params) => {
                return ContainerUtil.containerPushDataStyleFunction2(params, 'containerWeight')
              },
              valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
              editable: this.dgContainerEditable,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  precision: 3
                }
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            {
              headerName: this.$t('SeaExport.SealNo'),
              colId: 'sealNo',
              field: 'sealNo',
              width: 200,
              cellStyle: (params) => {
                return this.sealNoStyleFunction(params)
              },
              editable: this.dgContainerEditable,
              cellEditor: 'CargoAgGridCommonInputEditor',
              onCellValueChanged: p => this.onCellChange(p)
            },
            {
              headerName: this.$t('SeaExport.Quantity'),
              colId: 'quantity',
              field: 'quantity',
              width: 100,
              cellStyle: (params) => {
                return ContainerUtil.containerPushDataStyleFunction2(params, 'quantity')
              },
              valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
              editable: this.dgContainerEditable && this.isEdit,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  precision: 0
                },
                multiplePaste: { isNumber: true, precision: 0 }
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            {
              headerName: this.$t('SeaExport.GrossWeight'),
              colId: 'weight',
              field: 'weight',
              width: 100,
              cellStyle: (params) => {
                return ContainerUtil.containerPushDataStyleFunction2(params, 'weight')
              },
              valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
              editable: this.dgContainerEditable && this.isEdit,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  precision: 3
                },
                multiplePaste: { isNumber: true, precision: 3 }
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            {
              headerName: this.$t('SeaExport.Cubage'),
              colId: 'cubage',
              field: 'cubage',
              width: 100,
              cellStyle: (params) => {
                return ContainerUtil.containerPushDataStyleFunction2(params, 'cubage')
              },
              valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
              editable: this.dgContainerEditable && this.isEdit,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  precision: 3
                },
                multiplePaste: { isNumber: true, precision: 3 }
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            {
              headerName: this.$t('SeaExport.Soc'),
              colId: 'soc',
              field: 'soc',
              width: 100,
              cellRendererFramework: 'agGridColumnEdit',
              custom: {
                isEdit: this.dgContainerEditable && this.isEdit,
                tag: 'el-checkbox',
                valueChanged: p => {
                  this.onCellChange(p)
                }
              }
            },
            { headerName: this.$t('SeaExport.DestinationDeliveryTime'), field: 'destinationDeliveryTime', colId: 'destinationDeliveryTime', width: 120,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const destinationDeliveryTime = params.data.container.destinationDeliveryTime
                  return destinationDeliveryTime ? ColumnUtils.dateLabelFunc(destinationDeliveryTime) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'date',
                  format: 'yyyy-MM-dd',
                  valueFormat: 'yyyy-MM-dd',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const destinationDeliveryTime = params.data.container.destinationDeliveryTime
                  return destinationDeliveryTime ? ColumnUtils.dateLabelFunc(destinationDeliveryTime) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.DestinationReturnTime'), field: 'destinationReturnTime', colId: 'destinationReturnTime', width: 120,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const destinationReturnTime = params.data.container.destinationReturnTime
                  return destinationReturnTime ? ColumnUtils.dateLabelFunc(destinationReturnTime) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'date',
                  format: 'yyyy-MM-dd',
                  valueFormat: 'yyyy-MM-dd',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const destinationReturnTime = params.data.container.destinationReturnTime
                  return destinationReturnTime ? ColumnUtils.dateLabelFunc(destinationReturnTime) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.EmptyCabinetDate'), field: 'emptyCabinetDate', colId: 'emptyCabinetDate', width: 250,
              hide: true,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const emptyCabinetDate = params.data.container.emptyCabinetDate
                  return emptyCabinetDate ? ColumnUtils.dateMinutesLabelFunc(emptyCabinetDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const emptyCabinetDate = params.data.container.emptyCabinetDate
                  return emptyCabinetDate ? ColumnUtils.dateMinutesLabelFunc(emptyCabinetDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.RealArrivalsDate'), field: 'approachDate', colId: 'approachDate', width: 250,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const approachDate = params.data.container.approachDate
                  return approachDate ? ColumnUtils.dateMinutesLabelFunc(approachDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const approachDate = params.data.container.approachDate
                  return approachDate ? ColumnUtils.dateMinutesLabelFunc(approachDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.ActualLiftingDate'), field: 'actualLiftingDate', colId: 'actualLiftingDate', width: 250,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const actualLiftingDate = params.data.container.actualLiftingDate
                  return actualLiftingDate ? ColumnUtils.dateMinutesLabelFunc(actualLiftingDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const actualLiftingDate = params.data.container.actualLiftingDate
                  return actualLiftingDate ? ColumnUtils.dateMinutesLabelFunc(actualLiftingDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.DeliveryTime'), field: 'deliveryDate', colId: 'deliveryDate', width: 250,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const deliveryDate = params.data.container.deliveryDate
                  return deliveryDate ? ColumnUtils.dateMinutesLabelFunc(deliveryDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const deliveryDate = params.data.container.deliveryDate
                  return deliveryDate ? ColumnUtils.dateMinutesLabelFunc(deliveryDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.DeliveryDoneDate'), field: 'deliveryDoneDate', colId: 'deliveryDoneDate', width: 250,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const deliveryDoneDate = params.data.container.deliveryDoneDate
                  return deliveryDoneDate ? ColumnUtils.dateMinutesLabelFunc(deliveryDoneDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const deliveryDoneDate = params.data.container.deliveryDoneDate
                  return deliveryDoneDate ? ColumnUtils.dateMinutesLabelFunc(deliveryDoneDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.CleaningDate'), field: 'cleaningDate', colId: 'cleaningDate', width: 250,
              hide: true,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const cleaningDate = params.data.container.cleaningDate
                  return cleaningDate ? ColumnUtils.dateMinutesLabelFunc(cleaningDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const cleaningDate = params.data.container.cleaningDate
                  return cleaningDate ? ColumnUtils.dateMinutesLabelFunc(cleaningDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.ReturnBoxDate'), field: 'returnDate', colId: 'returnDate', width: 250,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const returnDate = params.data.container.returnDate
                  return returnDate ? ColumnUtils.dateMinutesLabelFunc(returnDate) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const returnDate = params.data.container.returnDate
                  return returnDate ? ColumnUtils.dateMinutesLabelFunc(returnDate) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.EmptyContainerNotificationTime'), field: 'emptyContainerNotificationTime', colId: 'emptyContainerNotificationTime', width: 250,
              hide: true,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const emptyContainerNotificationTime = params.data.container.emptyContainerNotificationTime
                  return emptyContainerNotificationTime ? ColumnUtils.dateMinutesLabelFunc(emptyContainerNotificationTime) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const emptyContainerNotificationTime = params.data.container.emptyContainerNotificationTime
                  return emptyContainerNotificationTime ? ColumnUtils.dateMinutesLabelFunc(emptyContainerNotificationTime) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.FreeContainerEndTime'), field: 'freeContainerEndTime', colId: 'freeContainerEndTime', width: 250,
              hide: true,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const freeContainerEndTime = params.data.container.freeContainerEndTime
                  return freeContainerEndTime ? ColumnUtils.dateMinutesLabelFunc(freeContainerEndTime) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const freeContainerEndTime = params.data.container.freeContainerEndTime
                  return freeContainerEndTime ? ColumnUtils.dateMinutesLabelFunc(freeContainerEndTime) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            { headerName: this.$t('SeaExport.FreeStorageEndTime'), field: 'freeStorageEndTime', colId: 'freeStorageEndTime', width: 250,
              hide: true,
              valueFormatter: (params) => {
                if (params.data && params.data.container) {
                  const freeStorageEndTime = params.data.container.freeStorageEndTime
                  return freeStorageEndTime ? ColumnUtils.dateMinutesLabelFunc(freeStorageEndTime) : ''
                }
                return ''
              },
              editable: this.isEdit,
              cellEditor: 'CargoAgGridDateTimeEditor',
              cellEditorParams: {
                props: {
                  type: 'datetime',
                  format: 'yyyy-MM-dd HH:mm',
                  valueFormat: 'yyyy-MM-dd HH:mm',
                  editable: false
                }
              },
              filterParams: {},
              filterValueGetter: (params) => {
                if (params.data && params.data.container) {
                  const freeStorageEndTime = params.data.container.freeStorageEndTime
                  return freeStorageEndTime ? ColumnUtils.dateMinutesLabelFunc(freeStorageEndTime) : ''
                }
                return ''
              },
              onCellValueChanged: p => this.onCellChange(p)
            },
            {
              headerName: this.$t('SeaExport.Remarks'),
              colId: 'remark',
              field: 'remark',
              width: 100,
              editable: this.dgContainerEditable && this.isEdit,
              cellEditor: 'CargoAgGridCommonInputEditor',
              onCellValueChanged: p => this.onCellChange(p)
            }
          ]
      if (this.isShowSize()) {
        defs.push(
          {
            headerName: this.$t('SeaExport.Dimensions'),
            field: 'dimension',
            colId: 'dimension',
            minWidth: 250,
            editable: this.dgContainerEditable && this.isEdit,
            suppressKeyboardEvent: true,
            cellEditor: 'CargoAgGridColumnEditGroup2',
            cellEditorParams: {
              valueChanged: this.calculationDimension,
              min: 0,
              precision: 2
            },
            onCellValueChanged: this.calculationDimension
          }
        )
      }
      return defs
    }
  },
  watch: {},
  created() {
  },
  methods: {
    onShow(row, isRefresh) {
      this.refreshTotal()
      if (!isRefresh) {
        return
      }

      this.job = row
      this.jobChanged()
    },
    async jobChanged() {
      if (!this.job) return

      const job = new SeaImportJob(this.job)

      await Promise.all([
        job.getSeaEQ(),
        job.getContainerUsages(),
        job.getContainers()
      ])

      await this.jobLoadResultHandler()

      // lcl 小票 通过 usage 关联出container
      if (job.lclMasterUuid) {
        const ctnr = []
        for (const item of job.containerUsages) {
          ctnr.push(item.container)
        }
        if (!job.containers) {
          job.containers = []
        }
        job.containers.splice(0, job.containers.length, ...ctnr)
      }

      // 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
      await ContainerUtil.buildContainerUsages(this.job)

      this.containerUsages = this.job.containerUsages

      await this.refreshContainerWeight()
      this.refreshTotal()

      if (this.job.lob === 'SI') {
        // CARGO-32264 海运操作-装箱信息页面 当整拼类型选择项目(POJ),私人物品(PVE)时，也要支持excel导入
        this.isFCL = this.job.containerLoadType === 'FCL' || this.job.containerLoadType === 'PVE' || this.job.containerLoadType === 'POJ'
      }
    },

    getSubmitData() {
      this.validate()
      // todo 过滤 isDirty = true 提交至后端保存 待全局测试

      const job = { ...this.job }
      for (const usage of this.job.containers) {
        usage.sizeLength = usage.sizeLength ? usage.sizeLength : 0
        usage.sizeWidth = usage.sizeWidth ? usage.sizeWidth : 0
        usage.sizeHeight = usage.sizeHeight ? usage.sizeHeight : 0
      }
      return {
        job, // 未打开过时 件毛体同步数据需要保存
        containers: this.job.containers.filter(p => p.isDirty === true),
        delContainerUuids: this.job.delContainerUuids // 删除的箱子uuid
      }
    },
    /**
       * 验证
       */
    validate() {
      if (!this.job || !this.job.containerUsages || !this.isEdit) {
        return true
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabContainer')
      }
      return true
    },
    async jobLoadResultHandler() {
      // 根据箱型初始化箱子(待审核的时候不允许看到装箱信息)
      if (this.job.jobState > SystemConstants.PENDING) {
        await ContainerUtil.autoJustContainerUsages(this.job, this.action)
      }

      // 避免 JSON 对象的循环引用  sortByMultiField 报错 ，后端排序
      // this.job.containerUsages = this.sortByOrder(this.job.containerUsages)

      this.selectedContainerUsage = null

      //  需要先 关联 container 与 containerUsage之后 调用
      // await this.refreshContainerWeight()

      // this.refreshTotal()
    },
    // 按照指定字段排序
    sortByOrder(categoryArray) {
      if (categoryArray == null || categoryArray.length === 0) {
        return null
      } else {
        categoryArray = sortByMultiField(categoryArray, ['dateCreated'], false)
      }
      return categoryArray
    },
    refreshContainerWeight() {
      for (const usage of this.containerUsages) {
        if (usage.container) {
          // 列显示 箱子相关信息 移至 usage
          const eqSize = EQSize.getEQSizeByCode(usage.container.eqSize)
          usage.eqSize = eqSize === null ? '' : eqSize.code
          usage.eqType = usage.container.eqType
          usage.containerNo = usage.container.containerNo
          usage.containerWeight = usage.container.containerWeight
          usage.sealNo = usage.container.sealNo
          usage.remark = usage.container.remark

          usage.approachDate = usage.container.approachDate
          usage.playDate = usage.container.playDate
          usage.loadingPort = usage.container.loadingPort
          usage.dischargingPort = usage.container.dischargingPort
          usage.destinationPort = usage.container.destinationPort
          usage.transportMessageDate = usage.container.transportMessageDate
          usage.wharfReleaseDate = usage.container.wharfReleaseDate
          usage.customReleaseDate = usage.container.customReleaseDate
          usage.containerAscription = usage.container.containerAscription
          usage.plateNumber = usage.container.plateNumber
          usage.plateApproachDate = usage.container.plateApproachDate
          usage.platePlayDate = usage.container.platePlayDate
          usage.emptyContainerNotificationTime = usage.container.emptyContainerNotificationTime
          usage.freeContainerEndTime = usage.container.freeContainerEndTime
          usage.freeStorageEndTime = usage.container.freeStorageEndTime

          usage.sizeLength = usage.container.sizeLength
          usage.sizeWidth = usage.container.sizeWidth
          usage.sizeHeight = usage.container.sizeHeight
          if ((!usage.sizeLength || usage.sizeLength === 0) && (!usage.sizeWidth || usage.sizeWidth === 0) && (!usage.sizeHeight || usage.sizeHeight === 0)) {
            usage.dimension = ''
          } else {
            usage.dimension = (usage.sizeLength && usage.sizeLength !== 0 ? usage.sizeLength : ' ') + '*' + (usage.sizeWidth && usage.sizeWidth !== 0 ? usage.sizeWidth : ' ') + '*' + (usage.sizeHeight && usage.sizeHeight !== 0 ? usage.sizeHeight : ' ')
          }
        }
      }
    },
    refreshTotal() {
      let quantity = 0
      let weight = 0
      let cubage = 0

      if (this.job.containerUsages && this.job.containerUsages.length > 0) {
        for (const usage of this.job.containerUsages) {
          quantity += usage.quantity
          if (!isNaN(usage.weight)) {
            weight += usage.weight
          }
          if (!isNaN(usage.cubage)) {
            cubage += usage.cubage
          }
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = ContainerUtil.getContainerDesc(this.job)
    },
    containerNbrStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage && !ContainerNoHelper.checkContainerNo(params.value)) {
          return { color: '#F56C6C' }
        }
      }
      return { color: '' }
    },
    sealNoStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage.isReSealed) {
          return { color: '#F56C6C' }
        }
      }
      return { color: '' }
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedContainerUsage = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainerUsage = node.data
          }
        })
      }
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    async onCellChange(params) {
      const _job = this.job
      const usage = params.data
      if (!usage) {
        return
      }
      usage.container.isDirty = true
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          usage.container.containerNo = usage.containerNo
          usage.container.syncToExport = true
          break
        case 'sealNo':
          usage.container.sealNo = usage.sealNo
          break
        case 'containerWeight':
          // 箱重处理四舍五入 入库（控件只做了前端显示处理）
          if (usage.containerWeight) {
            usage.containerWeight = roundHalfUp(usage.containerWeight, 3)
            usage.container.containerWeight = usage.containerWeight
          } else {
            usage.containerWeight = 0
            usage.container.containerWeight = usage.containerWeight
          }
          break
        case 'containerAscription':
          usage.container.containerAscription = usage.containerAscription
          break
        case 'remark':
          usage.container.remark = usage.remark
          break
        case 'mark':
          usage.container.mark = usage.mark
          break
        case 'quantity' :
          if (!usage.quantity) {
            usage.quantity = 0
          }
          // h5 不需要 quantityChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.quantity = usage.quantity
            }
          }
          usage.isDirty = true
          break
        case 'weight' :
          if (!usage.weight) {
            usage.weight = 0
          }
          // h5 不需要  weightChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.weight = usage.weight
            }
          }
          break
        case 'cubage' :
          if (!usage.cubage) {
            usage.cubage = 0
          }
          // h5 不需要  cubageChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.cubage = usage.cubage
            }
          }
          break
        case 'emptyCabinetDate':
          usage.container.emptyCabinetDate = usage.emptyCabinetDate
          break
        case 'approachDate':
          usage.container.approachDate = usage.approachDate
          break
        case 'actualLiftingDate':
          usage.container.actualLiftingDate = usage.actualLiftingDate
          break
        case 'deliveryDate':
          usage.container.deliveryDate = usage.deliveryDate
          break
        case 'deliveryDoneDate':
          usage.container.deliveryDoneDate = usage.deliveryDoneDate
          break
        case 'cleaningDate':
          usage.container.cleaningDate = usage.cleaningDate
          break
        case 'returnDate':
          usage.container.returnDate = usage.returnDate
          break
        case 'destinationDeliveryTime':
          usage.container.destinationDeliveryTime = usage.destinationDeliveryTime
          usage.container.syncToExport = true
          break
        case 'destinationReturnTime':
          usage.container.destinationReturnTime = usage.destinationReturnTime
          usage.container.syncToExport = true
          break
        case 'emptyContainerNotificationTime':
          usage.container.emptyContainerNotificationTime = usage.emptyContainerNotificationTime
          break
        case 'freeContainerEndTime':
          usage.container.freeContainerEndTime = usage.freeContainerEndTime
          break
        case 'freeStorageEndTime':
          usage.container.freeStorageEndTime = usage.freeStorageEndTime
          break
        case 'sizeLength':
          usage.container.sizeLength = usage.sizeLength
          break
        case 'sizeWidth':
          usage.container.sizeWidth = usage.sizeWidth
          break
        case 'sizeHeight':
          usage.container.sizeHeight = usage.sizeHeight
          break
        default :
          break
      }
      if (this.gridApi) this.gridApi.refreshCells({ force: true })
    },
    executeTask() {
      if (this.job && this.job.containers) {
        const containers = this.job.containers.filter(p => p.containerNo && p.syncToExport === true)
        if (this.job.trustFromJob && containers !== null && containers.length > 0) {
          syncContainersToExport(containers)
        }
      }
    },
    /**
       * 计算件毛体总数
       */
    refreshQWC() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.containerUsages) {
        quantity += usage.quantity
        if (!isNaN(usage.weight)) {
          weight += usage.weight
        }
        if (!isNaN(usage.cubage)) {
          cubage += usage.cubage
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
    },
    updateJobActualQWC() {
      ContainerUtil.refContainerUsageQwc(this.job, 1)
    },
    // 查验更改封号
    changeSealHandler() {
      if (!this.selectedContainerUsage) {
        return
      }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号 回调事件
    sealCloseHandler(data) {
      const usage = this.selectedContainerUsage
      if (usage.container.sealNo !== data.sealNo) {
        usage.isReSealed = true
        usage.container.inSpected = true
      }
      usage.container.sealNo = data.sealNo
      usage.container.containerNo = data.containerNo
      usage.container.remark = data.remark

      usage.container.isDirty = true

      // 箱子信息列字段移至 usage
      usage.sealNo = data.sealNo
      usage.containerNo = data.containerNo
      usage.remark = data.remark

      this.gridApi.refreshCells({ force: true })
    },
    // 自动装箱
    autoLoadHandler() {
      ContainerUtil.autoLoadContainerUsage(this.job)
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.containerUsages)
      this.refreshTotal()
    },
    // 清空装箱记录
    autoUnloadHandler() {
      const usage = this.selectedContainerUsage
      if (usage) {
        usage.container.containerNo = ''
        usage.container.sealNo = ''
        usage.weight = 0
        usage.quantity = 0
        usage.cubage = 0
        usage.hsCode = ''
        usage.container.cargoName = ''
        usage.cargoName = ''

        // 箱子信息列字段移至 usage
        usage.containerNo = ''
        usage.sealNo = ''

        usage.container.isDirty = true
        usage.isDirty = true
      }
      this.gridApi.refreshCells({ force: true })
      this.refreshTotal()
    },
    // 删除装箱记录
    deleteContainerHandler() {
      const items = this.gridApi.getSelectedRows()
      for (const usage of items) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(usage.uuid)) {
          if (!this.job.delContainerUuids) {
            this.job.delContainerUuids = []
          }
          this.job.delContainerUuids.push(usage.containerUuid)
        }

        const index = this.containerUsages.findIndex(p => p === usage)
        this.job.containerUsages.splice(index, 1)
      }
      this.refreshTotal()
    },
    // 刷新
    refresh() {
      if (this.job && !StrUtils.isEmpty(this.job.uuid)) {
        this.jobChanged()
      }
    },
    // 模板下载
    downTemplateBtn_clickHandler() {
      const fileName = 'SIContainerUsageImportTemPlate.xls'
      const folderName = 'booking'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // excel导入
    importExcelEventHandler(item) {
      const usages = lodash.cloneDeep(this.job.containerUsages)
      // 避免循环引用
      for (const usage of usages) {
        delete usage.container.containerUsage
      }

      const jobObj = { job: { lob: this.job.lob }, seaEQ: this.job.seaEQ, containerUsages: usages }
      const params = {
        file: item.file,
        job: JSON.stringify(jobObj),
        jobUuid: this.job.uuid,
        jobNo: this.job.jobNo
      }
      importExcelData(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.uploadSuccessUsage(response.data)
        }
      })
    },
    // excel导入 后数据处理 importFileHandler
    uploadSuccessUsage(data) {
      if (!data && !this.job) {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
        return
      }
      const usageCompare = []
      for (const usage of this.job.containerUsages) {
        const oldContainer = usage.container
        for (const newUsage of data.containerUsages) {
          // 记录 已匹配的数据 如已参与比较不再 比对
          if (usageCompare.findIndex(p => p === newUsage) > -1) {
            continue
          }
          const newContainer = newUsage.container
          if (oldContainer.eqSize === newContainer.eqSize && oldContainer.eqType === newContainer.eqType) {
            oldContainer.containerNo = newContainer.containerNo
            oldContainer.sealNo = newContainer.sealNo
            oldContainer.containerWeight = newContainer.containerWeight
            oldContainer.remark = newContainer.remark
            oldContainer.cargoName = newContainer.cargoName
            oldContainer.isDirty = true

            usage.containerNo = newContainer.containerNo
            usage.containerWeight = newContainer.containerWeight
            usage.sealNo = newContainer.sealNo
            usage.remark = newContainer.remark
            usage.containerWeight = newContainer.containerWeight
            usage.cargoName = newContainer.cargoName

            usage.quantity = newUsage.quantity
            usage.weight = newUsage.weight
            usage.cubage = newUsage.cubage
            usage.hsCode = newUsage.hsCode
            usage.soc = newUsage.soc
            usage.isDirty = true

            usageCompare.push(newUsage)

            break
          }
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    getPrintData() {
      const containerUsages = this.gridApi.getSelectedRows()
      if (containerUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return null
      }
      const params = {}
      params.job = this.job
      if (containerUsages.length === 1) {
        params.CONTAINER_UUID = containerUsages[0].containerUuid
        params.category = 'FCL'
        params.ctx = new SeaImportJob(this.job)
      } else {
        const uids = []
        for (var c of containerUsages) {
          if (!uids.includes(c.containerUuid)) {
            uids.push(c.containerUuid)
          }
        }
        params.CONTAINER_UUID = uids
        params.category = 'CONTAINER_LIST'
        params.ctx = new SeaImportJob(this.job)
      }
      return params
    },
    isShowSize() {
      if (this.containerUsages && this.containerUsages.length > 0) {
        for (const item of this.containerUsages) {
          if (item.eqType === 'OT' || item.eqType === 'FR') {
            return true
          }
        }
      }
      return false
    },
    calculationDimension(params) {
      const usage = params.data
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      usage.container.sizeLength = usage.sizeLength
      usage.container.sizeWidth = usage.sizeWidth
      usage.container.sizeHeight = usage.sizeHeight
      if ((!usage.sizeLength || usage.sizeLength === 0) && (!usage.sizeWidth || usage.sizeWidth === 0) && (!usage.sizeHeight || usage.sizeHeight === 0)) {
        usage.dimension = ''
      } else {
        usage.dimension = (usage.sizeLength || ' ') + '*' + (usage.sizeWidth || ' ') + '*' + (usage.sizeHeight || ' ')
      }
      this.gridOptions.api.refreshCells({ force: true })
    }
  }
}
</script>
<style lang='scss'>
  .data-red {
    color: #FF0000;
  }

  .data-blue {
    color: #0000ff;
  }

  #tabContainer {
    .data-red {
      input.el-input__inner {
        color: #FF0000;
      }
    }

    .data-blue {
      input.el-input__inner {
        color: #0000ff;
      }
    }
  }
</style>
